import React from 'react';
import { useParams } from 'react-router-dom';

const ImageHost = () => {
  const { imageName } = useParams();
  
  if (!imageName) {
    return <div>Image not found</div>;
  }

  const imagePath = `/images/mail-assets/${imageName}`;
  
  return (
    <div style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      backgroundColor: '#fff',
      zIndex: 9999
    }}>
      <img 
        src={imagePath} 
        alt={imageName}
        style={{ 
          maxWidth: '100%', 
          maxHeight: '100%',
          objectFit: 'contain',
          imageRendering: 'auto',
          filter: 'none'
        }}
        onLoad={() => console.log('Image loaded:', imagePath)}
        onError={(e) => {
          console.log('Image error:', imagePath);
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'block';
        }}
      />
      <div style={{ display: 'none', padding: '20px', fontSize: '18px' }}>
        Image not found: {imageName}<br/>
        Path: {imagePath}
      </div>
    </div>
  );
};

export default ImageHost;